import React from 'react'

import Text from '../text/Text'
import Pagination from '../pagination/Pagination'

import './TableInventory.css'
import { clevertapEvents, labels } from '../../labels'
import { track } from '../../ClevertapWrapper'
import routes from '../../router/routes'
import { format } from 'date-fns'
import { isAdmin } from '../../Utils/Profile'
import { formatCurrency } from '../../utils'
import SvgIcon from '../svgIcon/SvgIcon'
import ImageDefault from '../../assets/images/image-default.png'

interface ITableInventory {
    listProducts: IProductObject[]
    listTitles: string[]
    liquidate: (item: IProductObject) => void
    stopLiquidating: (item: IProduct) => void
    onPageChange: (page: number) => void
    onSort: (item: string) => void
    pageSize: number
    totalPage: number
    currentPage: number
    onUpdateClick: (data: IProductObject) => void
    view: (item: IProductObject) => void
    onDelete: (item: IProductObject) => void
}

function TableInventory({
    listProducts,
    listTitles,
    liquidate,
    stopLiquidating,
    onPageChange,
    onSort,
    pageSize,
    totalPage,
    currentPage,
    onUpdateClick,
    view,
    onDelete,
}: ITableInventory) {
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const inventoryEventParms = {
        pageName: 'TableInventory',
        pageURL: routes.inventory,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        nombreComercio: user?.sNombre,
        codLocal: user?.cLocal[0].sLocal,
        rut: user?.sRut,
        mailLogin: user?.sEmailContacto,
    }

    return (
        <div className="container-table">
            <table>
                <thead style={{ height: '35px' }}>
                    <tr>
                        {listTitles.map((item) => {
                            return (
                                <th
                                    key={item}
                                    className={
                                        item === 'Descripción'
                                            ? 'thDescripcion'
                                            : item === 'Precio'
                                            ? 'thPrecio'
                                            : item === 'Imagen'
                                            ? 'thImagen'
                                            : ''
                                    }
                                    onClick={() => onSort(item)}
                                >
                                    <Text
                                        label={item}
                                        variant="text-title-table"
                                    />
                                </th>
                            )
                        })}
                    </tr>
                </thead>
                <tbody>
                    {listProducts.map((item) => {
                        return (
                            <tr key={item.product.id} className="trList">
                                <td className="inventory-promotion-img-container">
                                    <div
                                        style={{
                                            height: 75,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <img
                                            src={
                                                item.product.photoURL
                                                    ? item.product.photoURL
                                                    : ImageDefault
                                            }
                                            width="45px"
                                            height="45px"
                                        />
                                    </div>
                                    {item.product.promotion && (
                                        <div className="inventory-promotion-label">
                                            <Text
                                                label="En promoción"
                                                fontSize={10}
                                                fontWeight={600}
                                                textAlign="center"
                                                color="white"
                                            />
                                        </div>
                                    )}
                                    {item.product.settlement && (
                                        <div className="inventory-promotion-label">
                                            <Text
                                                label="En liquidación"
                                                fontSize={10}
                                                fontWeight={600}
                                                textAlign="center"
                                                color="white"
                                            />
                                        </div>
                                    )}
                                    {item.product.provisorio && (
                                        <div
                                            className="inventory-promotion-label"
                                            style={{
                                                backgroundColor: '#1889C5',
                                            }}
                                        >
                                            <Text
                                                label="Provisorio"
                                                fontSize={10}
                                                fontWeight={600}
                                                textAlign="center"
                                                color="white"
                                            />
                                        </div>
                                    )}
                                </td>

                                <td
                                    style={{
                                        padding: 10,
                                        maxWidth: 160,
                                        textAlign: 'left',
                                    }}
                                >
                                    <div className="list-product-tooltip-name-content">
                                        <p className={`product-name-text`}>
                                            {item.product.productName?.length >
                                            31
                                                ? `${item.product.productName.substring(
                                                      0,
                                                      31
                                                  )}...`
                                                : item.product.productName}
                                        </p>
                                        {item.product.productName.length >
                                            31 && (
                                            <div className="list-product-tooltip-name">
                                                {item.product.productName}
                                            </div>
                                        )}
                                    </div>
                                </td>

                                <td
                                    style={{
                                        padding: 10,
                                        maxWidth: 90,
                                        textAlign: 'left',
                                    }}
                                >
                                    <div className="list-product-tooltip-name-content">
                                        <p className={`product-name-text`}>
                                            {item.product.ean?.length > 13
                                                ? `${item.product.ean.substring(
                                                      0,
                                                      13
                                                  )}...`
                                                : item.product.ean}
                                        </p>
                                        {item.product.ean?.length > 13 && (
                                            <div className="list-product-tooltip-name">
                                                {item.product.ean}
                                            </div>
                                        )}
                                    </div>
                                </td>

                                <td>
                                    <Text
                                        label={formatCurrency(
                                            item.productPrices[0].saleAmount.toString()
                                        )}
                                        variant="text-info-table"
                                    />
                                </td>

                                <td>
                                    <Text
                                        label={item.commerceStock.stock.toString()}
                                        variant="text-info-table"
                                    />
                                </td>

                                <td>
                                    {item.commerceStock.f2f && (
                                        <div className="inventory-table-disponible-content">
                                            <div className="inventory-table-disponible-icon-cart">
                                                <SvgIcon iconName="CartProduct" />
                                            </div>
                                            <Text
                                                label="Venta presencial"
                                                variant="text-info-table"
                                                fontSize={12}
                                                fontWeight={600}
                                                color="#656565"
                                                fontFamily="Montserrat"
                                            />
                                        </div>
                                    )}
                                    {item.commerceStock.online && (
                                        <div className="inventory-table-disponible-content">
                                            <div className="inventory-table-disponible-icon-amipass">
                                                <SvgIcon iconName="IconAmipass" />
                                            </div>
                                            <Text
                                                label="Venta en app"
                                                variant="text-info-table"
                                                fontSize={12}
                                                fontWeight={600}
                                                color="#656565"
                                                fontFamily="Montserrat"
                                            />
                                        </div>
                                    )}
                                </td>

                                <td>
                                    {!item.product.promotion &&
                                        (!item.product.settlement ? (
                                            <div className="actions">
                                                {!isAdmin() ? (
                                                    <button
                                                        className="button-view"
                                                        onClick={() =>
                                                            view(item)
                                                        }
                                                    >
                                                        <Text
                                                            label="ver"
                                                            fontSize={13}
                                                            color="#565656"
                                                            fontWeight={600}
                                                        />
                                                    </button>
                                                ) : (
                                                    <>
                                                        <button
                                                            onClick={() => {
                                                                onUpdateClick(
                                                                    item
                                                                )

                                                                track(
                                                                    clevertapEvents.amiposweb_impulsatusventas_marketplace_misproductos_editar,
                                                                    inventoryEventParms
                                                                )
                                                            }}
                                                            className="edit-product"
                                                        >
                                                            <div>
                                                                <SvgIcon
                                                                    width={18}
                                                                    height={18}
                                                                    iconName="IconsEditAltBlue"
                                                                />
                                                            </div>
                                                            <Text
                                                                label={
                                                                    labels.editProduct
                                                                }
                                                                fontSize={13}
                                                                color="#2699D6"
                                                                fontWeight={600}
                                                            />
                                                        </button>

                                                        {item.commerceStock
                                                            .online && (
                                                            <button
                                                                className="button-lidation"
                                                                onClick={() => {
                                                                    liquidate(
                                                                        item
                                                                    )
                                                                    track(
                                                                        clevertapEvents.amiposweb_impulsatusventas_marketplace_misproductos_liquidar,
                                                                        inventoryEventParms
                                                                    )
                                                                }}
                                                            >
                                                                <div>
                                                                    <SvgIcon
                                                                        width={
                                                                            18
                                                                        }
                                                                        height={
                                                                            18
                                                                        }
                                                                        iconName="BIconsDiscount"
                                                                    />
                                                                </div>
                                                                <Text
                                                                    label="Liquidar producto"
                                                                    fontSize={
                                                                        13
                                                                    }
                                                                    color="#565656"
                                                                    fontWeight={
                                                                        600
                                                                    }
                                                                />
                                                            </button>
                                                        )}

                                                        <button
                                                            className="button-lidation"
                                                            onClick={() => {
                                                                onDelete(item)
                                                            }}
                                                        >
                                                            <div>
                                                                <SvgIcon
                                                                    width={18}
                                                                    height={18}
                                                                    iconName="trash"
                                                                />
                                                            </div>
                                                            <Text
                                                                label="Eliminar"
                                                                fontSize={13}
                                                                color="#565656"
                                                                fontWeight={600}
                                                            />
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                        ) : (
                                            <>
                                                {isAdmin() ? (
                                                    <button
                                                        className="button-lidation"
                                                        onClick={() =>
                                                            stopLiquidating(
                                                                item.product
                                                            )
                                                        }
                                                    >
                                                        <div>
                                                            <SvgIcon
                                                                width={18}
                                                                height={18}
                                                                iconName="BIconsDiscount"
                                                            />
                                                        </div>
                                                        <Text
                                                            label="Dejar de Liquidar"
                                                            fontSize={13}
                                                            color="#565656"
                                                            fontWeight={600}
                                                        />
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="button-view"
                                                        onClick={() =>
                                                            view(item)
                                                        }
                                                    >
                                                        <Text
                                                            label="ver"
                                                            fontSize={13}
                                                            color="#565656"
                                                            fontWeight={600}
                                                        />
                                                    </button>
                                                )}
                                            </>
                                        ))}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            <Pagination
                className="pagination-bar"
                currentPage={currentPage}
                totalCount={totalPage}
                pageSize={pageSize}
                onPageChange={onPageChange}
            />
        </div>
    )
}

export default TableInventory
